<div class="ub-filter-list">
  <ng-content class="ub-filter-list__label" select="[label]"></ng-content>
  <div class="ub-filter-list__filters">
    <ng-content select="[filters]"></ng-content>
  </div>
</div>
